<template>
  <div class="main fictionList">
    <div class="nav">
      <div class="left" @click="$router.go(-1)">
        <div class="icon_back"></div>
      </div>
      小说详情
      <div class="share" @click="onshare()">
        <div></div>
      </div>
    </div>
    <div class="content">
      <div class="anchor_user">
        <div class="img_user">
          <viewer style="width: 100%; height: 100%">
            <img :src="detailsNovel.img" />
          </viewer>
        </div>
        <div class="anchor_status">
          <router-link
            class="list_details"
            :to="{
              path: '/hosDetails',
              query: {
                aid: detailsNovel.anchor_id,
                platform: $route.query.platform,
                ver: $route.query.ver,
              },
            }"
          >
            <p>
              {{ detailsNovel.name
              }}<span class="label_t">{{ detailsNovel.category_name }}</span>
            </p>
            <div class="exhibition">
              <span>
                <i>
                  <img src="../assets/images/home_ic_label.png" alt />
                </i>
                <span class="girlName">{{ detailsNovel.anchor_name }}</span>
              </span>
              <span>
                <i>
                  <img src="../assets/images/ic_heat.png" alt />
                </i>
                <span v-if="detailsNovel.listen_type == 1">{{
                  detailsNovel.listen_true
                }}</span>
                <span v-if="detailsNovel.listen_type == 2">{{
                  detailsNovel.listen
                }}</span>
              </span>
            </div>
            <p>
              状态：
              <span v-if="detailsNovel.update_status == 1" class="color_active"
                >更新至 {{ numAll }} 期</span
              >
              <span v-if="detailsNovel.update_status == 2" class="color_end"
                >已完结</span
              >
            </p>
          </router-link>
          <div
            class="down_img"
            @click="downLoadEvt($route.query.nid)"
            v-if="verNum >= 229"
          >
            <img src="../assets/images/down.png" alt="" />
            <p>下载</p>
          </div>
          <div class="btn_attention">
            <div v-if="FocusState == 2" @click="attention()">+ 关注</div>
            <div v-if="FocusState == 1" @click="attention()" class="active">
              已关注
            </div>
          </div>
        </div>
        <div class="recommend">
          <p>简介</p>
          <div>
            <p>{{ detailsNovel.introduction }}</p>
          </div>
        </div>
      </div>
      <div class="directory">
        <div class="title">目录</div>
        <div class="choose_list">
          <van-list v-model="loading" :finished="finished" @load="faechPage">
            <van-cell
              v-for="(item, index) in VideoList"
              :key="index"
              class="list_item"
            >
              <!-- <div class="list_item" v-for="(item , index) in VideoList" :key="index" @click="lookNovel(item)"> -->
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
                @click="lookNovel(item)"
              >
                <!-- <div class="resd_order" v-if="historyKey && !musicId">
                          <span v-if="historyKey == item.id" class="demo2"></span>
                          <span v-else>{{item.numbers}}</span>
                </div>-->
                <div class="resd_order">
                  <!-- <span v-if="musicId == item.id && status == false " class="demo2"></span>
                  <span v-else class="demo1"></span>-->
                  <span class="demo1"></span>
                </div>
                <div class="read_info">
                  <p>{{ item.name }}</p>
                  <p>
                    <i>
                      <img src="../assets/images/sc_time.png" alt />
                    </i>
                    {{ formatSeconds(item.duration) }}
                  </p>
                </div>
                <!-- <div class="jz_down" @click="downLoadEvt(item.nid, item.id, $event)" v-if="verNum >=229">
                  <img src="../assets/images/down.png" alt="" />
                </div> -->
                <!-- <div class="free" v-if="item.is_free == 1 ">免费</div>
                <div class="toll" v-if="item.is_free == 2 ">收费</div>-->
              </div>
            </van-cell>
          </van-list>
        </div>
      </div>
      <div
        v-if="!loading && finished"
        class="No_more"
        style="text-align: center"
      >
        我也是有底线的
      </div>
    </div>
    <!-- <playerMask :showstate='showa1' @tocancel='okfall'></playerMask> -->
  </div>
</template>
  
  <script>
import { mapState, mapMutations, mapActions } from "vuex";
import "../css/fiction.scss";
import playerMask from "../components/player";
import { useLocal } from "../plugin/tools";
export default {
  components: { playerMask },
  name: "fictionList",
  data() {
    return {
      detailsNovel: {},
      FocusState: {},
      VideoList: [],
      numAll: "",
      listParams: {
        page: 0,
        pageSize: 10,
        nid: 0,
      },
      loading: false,
      finished: false,
      url: "",
      text: "",
      gzID: "",
      acname: "",
      // historyzb: []
    };
  },
  computed: {
    ...mapState("userIndex", [
      "UserData",
      "showa1",
      "musicId",
      "Token",
      "musicName",
      "novelSection",
      "historyKey",
      "musicListid",
      "historyData",
      "iconFlag",
      "status",
      "NovelDetail",
      "chapterList",
      "verNum",
    ]),
  },
  watch: {
    $route(to, from) {
      if (to) {
        this.finished = true;
        this.listParams.page = 1;
        this.listParams.pageSize = 10;
        // 默认清空
        this.VideoList = [];
        this.getAllList();
      }
    },
  },

  created() {
    if (!useLocal("remian")) {
      useLocal("remian", 2);
    }
    this.queryData = this.$route.query || {};
    let query = this.$route.query;

    this.fetchNovelDetail(query).then((res) => {
      this.detailsNovel = res.data;
      this.gzID = res.data.anchor_id;
      this.acname = res.data.name;
      // console.log(this.acname);
      let obj = {
        aid: res.data.anchor_id,
      };
      this.fetchAnchor(obj).then((res) => {
        this.FocusState = res.data;
      });
    });
    this.fecthShare().then((res) => {
      this.url = res.data.url;
      this.text = res.data.text;
    });
    this.fetchUserInfo();

    if (window && window.android) {
      window.android.showBookInfoGuide();
    }
    if (window && window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.showBookInfoGuide.postMessage({});
    }
  },
  mounted() {
    setTimeout(() => {
      this.sensors.track(
        "YS_Intro_Page",
        {
          work_id: this.NovelDetail.id,
          total_chapter_num: this.chapterList.numbers_sum,
          author_id: this.NovelDetail.anchor_id,
          refer_page: `${this.$route.query.refer}_${this.$route.query.referId}_${this.$route.query.lmId}`,
        },
        () => {
          console.log("success");
        }
      );
    }, 1500);
  },
  methods: {
    ...mapActions("userIndex", [
      "fecthShare",
      "fetchNovelDetail",
      "fetchChapter",
      "fetchAnchor",
      "fetchUserInfo",
      "fetchAttention",
      "fetchHistoryList",
      "fetchPlayUrl",
    ]),
    ...mapMutations("userIndex", [
      "setUserData",
      "setToken",
      "setMusicId",
      "setMusicName",
      "setShowa1",
      "setNovelSection",
      "setHistoryKey",
      "setMusicListid",
      "setHistoryData",
      "setIconFlag",
      "setStatus",
      "setverNum",
    ]),

    // 初始化数据
    getAllList() {
      this.loading = true;
      this.listParams.nid = this.$route.query.nid;
      this.fetchChapter(this.listParams).then((res) => {
        this.loading = false;
        if (!res || res.data == "" || res.data.novelChapter == 0) {
          this.finished = true;
          return false;
        }
        this.finished = false;
        this.numAll = res.data.numbers_sum;
        this.VideoList = res.data.novelChapter;
      });
    },
    faechPage() {
      this.listParams.page++;
      this.loading = true;
      this.listParams.nid = this.$route.query.nid;
      this.fetchChapter(this.listParams).then((res) => {
        this.loading = false;
        if (!res || res.data == "" || res.data.novelChapter == 0) {
          this.finished = true;
          return false;
        }
        this.numAll = res.data.numbers_sum;
        this.VideoList = this.VideoList.concat(res.data.novelChapter);
        // console.log(res.data.novelChapter)
        // this.VideoList = res.token.novelChapter
      });
      setTimeout(() => {
        this.sensors.track(
          "YS_Intro_Page",
          {
            work_id: this.NovelDetail.id,
            total_chapter_num: this.chapterList.numbers_sum,
            author_id: this.NovelDetail.anchor_id,
            refer_page: `${this.$route.query.refer}_${this.$route.query.referId}_${this.$route.query.lmId}`,
          },
          () => {
            console.log("success");
          }
        );
      }, 2000);
    },

    lookNovel(item) {
      // if (item.is_free == 1) {
      if (this.Token || useLocal("remian") > 1) {
        let query = this.$route.query.nid;
        this.setMusicName(item.name);
        this.$router.push({
          path: "/player",
          query: {
            ncid: item.id,
            nid: query,
            acname: this.acname,
            ver: this.$route.query.ver,
          },
        });
      } else {
        this.$dialog
          .confirm({
            message: "您已用完游客收听次数，请登录畅听",
          })
          .then(() => {
            if (window && window.android) {
              window.android.thirdpartyLogin();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
            }
          });
      }
      // }
      // if (item.is_free == 2 && this.UserData == null) {
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       if (window && window.android) {
      //         window.android.thirdpartyLogin();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.thirdpartyLogin.postMessage({});
      //       }
      //     });
      //   return;
      // }

      // if (item.is_free == 2 && this.UserData.payment_status == 1) {
      //   this.$dialog
      //     .confirm({
      //       message: "请登录且开通VIP，VIP会员全部免费畅听！",
      //     })
      //     .then(() => {
      //       if (window && window.android) {
      //         window.android.pay();
      //       }
      //       if (window && window.webkit && window.webkit.messageHandlers) {
      //         window.webkit.messageHandlers.pay.postMessage({});
      //       }
      //     });
      //   return;
      // }

      // if (item.is_free == 2 && this.UserData.payment_status == 2) {
      //   let query = this.$route.query.nid;
      //   this.setMusicName(item.name);
      //   this.$router.push({
      //     path: "/player",
      //     query: {
      //       ncid: item.id,
      //       nid: query,
      //     },
      //   });
      // }
    },
    formatBit(val) {
      val = +val;
      return val > 9 ? val : "0" + val;
    }, // 秒转时分秒，求模很重要，数字的下舍入
    formatSeconds(time) {
      let min = Math.floor(time % 3600);
      let val =
        this.formatBit(Math.floor(time / 3600)) +
        ":" +
        this.formatBit(Math.floor(min / 60)) +
        ":" +
        this.formatBit(time % 60);
      return val;
    },
    //复制
    onshare() {
      this.$copyText(this.text + ' ' + this.url).then(() => {
        this.$toast({
          message: '已成功复制到剪贴板！',
          forbidClick: true,
          duration: 1000,
        });
      });
    },
    attention() {
      let query = this.$route.query;
      if (this.FocusState == 1) {
        let obj = {
          aid: this.gzID,
          type: 2,
        };
        this.fetchAttention(obj).then((res) => {
          if (res.code == 200) {
            this.$dialog({
              message: "取消关注成功",
            });
            this.fetchNovelDetail(query).then((res) => {
              this.detailsNovel = res.data;
              this.gzID = res.data.anchor_id;
              let obj = {
                aid: res.data.anchor_id,
              };
              this.fetchAnchor(obj).then((res) => {
                this.FocusState = res.data;
              });
            });
          } else {
            this.$dialog
              .confirm({
                message: "登录后才能关注",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                  query: {
                    platform: this.$route.query.platform,
                  },
                });
              });
          }
        });
      } else {
        let obj = {
          aid: this.gzID,
          type: 1,
        };
        this.fetchAttention(obj).then((res) => {
          if (res.code == 200) {
            this.$dialog({
              message: "关注成功",
            });
            this.fetchNovelDetail(query).then((res) => {
              this.detailsNovel = res.data;
              this.gzID = res.data.anchor_id;
              let obj = {
                aid: res.data.anchor_id,
              };
              this.fetchAnchor(obj).then((res) => {
                this.FocusState = res.data;
              });
            });
          } else {
            this.$dialog
              .confirm({
                message: "登录后才能关注",
              })
              .then(() => {
                this.$router.push({
                  path: "/login",
                  query: {
                    platform: this.$route.query.platform,
                  },
                });
              });
          }
        });
      }
    },
    /**
     * 下载
     * nid 小说id
     */
    downLoadEvt(nid, e) {
      // 普通用户给予提示付费
      if (this.UserData.payment_status == 1) {
        this.$dialog
          .confirm({
            message: "VIP会员可以免费下载哦~",
          })
          .then(() => {
            if (window && window.android) {
              window.android.pay();
            }
            if (window && window.webkit && window.webkit.messageHandlers) {
              window.webkit.messageHandlers.pay.postMessage({});
            }
          })
          .catch(() => {});
      } else {
        if (window.android && window.android.getDownBoyinChapter) {
          window.android.getDownBoyinChapter(Number(nid));
        }

        if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.getDownBoyinChapter.postMessage(
            Number(nid)
          );
        }
      }
    },
  },
};
</script>
